import { FEDERATED_APP_SETTINGS } from 'common/constants/constants';
import { loadRemoteApp, resolveRemoteUrl } from 'common/utils/moduleFederation';
import ErrorBoundary from 'components/ErrorBoundary';
import { CenterLoader } from 'connected-components/Loader/Loader';
import { ComponentType, Suspense, lazy } from 'react';
import { AutomationsAppProps } from 'types/micro-frontends';
import { useSelector } from 'react-redux';
import {
  dateRangeSelector,
  selectedTeamSelector
} from 'state/selectors/ui-state';
import { repositoriesSelector } from 'state/selectors/repositories';
import useSettingsService from 'components/hooks/useSettingsService';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { activeGitIntegrationsSelector } from 'state/selectors/sensors-authorizations';
import { useHistory } from 'react-router';

const app = FEDERATED_APP_SETTINGS.AUTOMATIONS;

const url = resolveRemoteUrl(process.env.NODE_ENV, window.location, app, true);

const AutomationsApp = lazy<ComponentType<AutomationsAppProps>>(
  loadRemoteApp(url, app)
);

export function Automations() {
  const history = useHistory();

  // in the future we can pass ui-state instead of the current props
  const dateRange = useSelector(dateRangeSelector);
  const currentTeam = useSelector(selectedTeamSelector);
  const orgRepos = useSelector(repositoriesSelector);
  const gitIntegrations = useSelector(activeGitIntegrationsSelector);

  const { getSettingOrDefinitionValue } = useSettingsService();

  const enableMarketplace = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.automationsMarketplaceViewEnable
  });

  const isAutomationInspectionEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.automationInspectionEnabled
  });

  const gitProvidersEnabled: string[] = Array.from(
    new Set(gitIntegrations.map(integration => integration.sensor_name))
  );

  return (
    <ErrorBoundary>
      <Suspense fallback={<CenterLoader />}>
        <AutomationsApp
          dateRange={dateRange}
          currentTeam={currentTeam}
          orgRepos={orgRepos}
          enableMarketplace={enableMarketplace}
          gitProvidersEnabled={gitProvidersEnabled}
          isAutomationInspectionEnabled={isAutomationInspectionEnabled}
          history={history}
        />
      </Suspense>
    </ErrorBoundary>
  );
}
